export default __webpack_public_path__ + "static/media/lua.be494b08.svg";